export default __webpack_public_path__ + "static/media/tab-02.3d5412dd.svg";